<template>
  <header :class="compact ? 'mb-6' : 'mb-8'">
    <p
      v-if="eyebrow"
      class="text-sm font-semibold text-brand-600 uppercase tracking-wide mb-2"
    >
      {{ eyebrow }}
    </p>
    <div class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div class="min-w-0">
        <component
          :is="heading"
          class="text-2xl font-bold text-highlighted md:text-3xl"
        >
          {{ title }}
        </component>
        <p v-if="subtitle" class="mt-2 max-w-2xl text-toned">
          {{ subtitle }}
        </p>
      </div>
      <div v-if="$slots.actions" class="shrink-0">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  eyebrow?: string
  title: string
  subtitle?: string
  heading?: 'h1' | 'h2'
  compact?: boolean
}>(), {
  heading: 'h2',
  compact: false,
})
</script>
